import { render, staticRenderFns } from "./checkpoint-patch-new.vue?vue&type=template&id=2b848177&scoped=true&"
import script from "./checkpoint-patch-new.vue?vue&type=script&lang=ts&"
export * from "./checkpoint-patch-new.vue?vue&type=script&lang=ts&"
import style0 from "./checkpoint-patch-new.vue?vue&type=style&index=0&id=2b848177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b848177",
  null
  
)

export default component.exports